<template>
  <main-container>
    <common-header/>
    <section-heading>ご利用可能回数確認</section-heading>
    <contents-container>
      <contents-text>最新購入端末に対する利用回数が表示されます。<br>ご不明な点はお問い合わせください。</contents-text>
      <contents-text><small-text>サポート期間は前後する可能性がございます</small-text></contents-text>
      <contents-heading>ご契約情報</contents-heading>
      <border-container v-for="(deviceInfo, index) in deviceInfoList" variant="border" :key="index">
        <item-container>
          <heading-label>電話番号</heading-label>
          <contents-text variant="bold">{{deviceInfo.tel}} <template v-if="deviceInfo.deviceName">（{{deviceInfo.deviceName}}）</template></contents-text>
        </item-container>
        <item-container>
          <heading-label>サポート期間</heading-label>
          <template v-if="deviceInfo.serviceType === 1 || deviceInfo.serviceType === 2 || deviceInfo.serviceType === 3">
            <contents-text v-if="deviceInfo.isExpired" variant="bold">サポート期間満了</contents-text>
            <contents-text v-else variant="bold">{{deviceInfo.supportPeriodFrom}}~{{deviceInfo.supportPeriodTo}}</contents-text>
          </template>
          <contents-text v-else-if="deviceInfo.serviceType === 4" variant="bold">端末登録申請日から２年間</contents-text>
          <contents-text v-else-if="deviceInfo.serviceType === 5" variant="bold">対象外</contents-text>
        </item-container>
        <right-count-container v-if="deviceInfo.serviceType === 1">
          <right-count-box :count="deviceInfo.isExpired ? null : deviceInfo.numberOfRepair">修理補償</right-count-box>
          <right-count-box :count="null">紛失補償</right-count-box>
        </right-count-container>
        <right-count-container v-else-if="deviceInfo.serviceType === 2">
          <right-count-box :count="deviceInfo.isExpired ? null : deviceInfo.numberOfRepair">修理補償</right-count-box>
          <right-count-box :count="deviceInfo.isExpired ? null : deviceInfo.numberOfLost">紛失補償</right-count-box>
        </right-count-container>
        <right-count-container v-else-if="deviceInfo.serviceType === 3">
          <right-count-box :count="deviceInfo.isExpired ? null : deviceInfo.numberOfInsurance">修理(保険)</right-count-box>
        </right-count-container>
        <item-container v-else-if="deviceInfo.serviceType === 4">
          <contents-text>利用可能回数のご確認は、<inline-link @click="entryListLink(deviceInfo.carrierType)">端末情報事前登録一覧画面</inline-link>にてご確認ください。</contents-text>
        </item-container>
        <item-container v-else-if="deviceInfo.serviceType === 5">
          <contents-text><small-text>本端末はサポート対象外になります。</small-text></contents-text>
        </item-container>
      </border-container>
      <button-container>
        <button-main :to="{ name:'rep010', params: {id: this.$route.query.p}}">戻る</button-main>
      </button-container>
      <common-support/>
      <button-container>
        <button-main href="https://pass.auone.jp/my-page">auスマートパス&emsp;マイページ</button-main>
      </button-container>
    </contents-container>
    <common-footer/>
    <common-loading v-if="isLoading"/>
  </main-container>
</template>

<script>
  import { postRefRightCountApi } from '../utils/ApiHelper'

  import CommonHeader from '../components/common/CommonHeader'
  import CommonFooter from '../components/common/CommonFooter'
  import CommonSupport from '../components/common/CommonSupport'
  import CommonLoading from '../components/common/CommonLoading'
  import MainContainer from '../components/container/MainContainer'
  import ContentsContainer from '../components/container/ContentsContainer'
  import BorderContainer from '../components/container/BorderContainer'
  import ItemContainer from '../components/container/ItemContainer'
  import SectionHeading from '../components/heading/SectionHeading'
  import ContentsHeading from '../components/heading/ContentsHeading'
  import HeadingLabel from '../components/heading/HeadingLabel'
  import ContentsText from '../components/text/ContentsText'
  import SmallText from '../components/text/SmallText'
  import ButtonContainer from '../components/button/ButtonContainer'
  import ButtonMain from '../components/button/ButtonMain'

  import ErrorMixin from '../components/mixin/ErrorMixin'
  import RightCountBox from "../components/text/RightCountBox";
  import RightCountContainer from "../components/container/RightCountContainer";
  import InlineLink from "../components/text/InlineLink";

  export default {
    name: "rep050",
    components: {
      InlineLink,
      RightCountContainer,
      RightCountBox,
      CommonHeader,
      CommonFooter,
      CommonSupport,
      CommonLoading,
      MainContainer,
      ContentsContainer,
      BorderContainer,
      ItemContainer,
      SectionHeading,
      ContentsHeading,
      HeadingLabel,
      ContentsText,
      SmallText,
      ButtonContainer,
      ButtonMain
    },
    mixins: [ErrorMixin],
    data () {
      return {
        deviceInfoList: [],
        isLoading: false,
      }
    },
    methods: {
      entryListLink (carrierType) {
        this.$store.dispatch('setCarrierType', carrierType)
        this.$router.push({ name:'rep030', query: {'p': this.$route.query.p}})
      }
    },
    mounted () {
      this.isLoading = true
      postRefRightCountApi()
        .then(res => {
          const result = res.data.result
          if (!this.$_isError(result)) {
            this.deviceInfoList = result.deviceInfoList
            this.isLoading = false
          }
        })
        .catch(() => {
          this.$router.push({name: 'rep320', query: {'p': this.$route.query.p}})
        })
    }
  }
</script>
<style lang="scss" scoped>
</style>
